import React, { useState } from 'react';
import { useTranslation } from 'next-i18next';
import useWindowSize from '@hooks/use-window-size';
import clsx from 'clsx';
import Icon from '@components/atoms/icon/icon';
import styles from './account-settings-layout.module.scss';

export enum AccountSettingsTab {
  INFO = 'info',
  NOTIFICATIONS = 'notifications',
  ADDRESSES = 'addresses',
  PAYMENTS = 'payments',
}

export const ACCOUNT_SETTINGS_TABS = Object.values(AccountSettingsTab);

export const DEFAULT_TAB = AccountSettingsTab.INFO;

const TAB_NAV_ITEMS: { tab: AccountSettingsTab; translationKey: string }[] = [
  { tab: AccountSettingsTab.INFO, translationKey: 'ACCOUNT_SETTINGS.MENU.ACCOUNT' },
  { tab: AccountSettingsTab.NOTIFICATIONS, translationKey: 'ACCOUNT_SETTINGS.MENU.EMAIL' },
  { tab: AccountSettingsTab.ADDRESSES, translationKey: 'ACCOUNT_SETTINGS.MENU.ADDRESSES' },
  { tab: AccountSettingsTab.PAYMENTS, translationKey: 'ACCOUNT_SETTINGS.MENU.PAYMENT_METHODS' },
];

interface AccountSettingsLayoutProps {
  activeTab: AccountSettingsTab;
  onTabChange: (tab: AccountSettingsTab) => void;
  children: React.ReactNode;
}

const AccountSettingsLayout: React.FC<AccountSettingsLayoutProps> = ({ activeTab, onTabChange, children }) => {
  const { t } = useTranslation('account-settings');
  const { t: tCommon } = useTranslation('common');
  const { isWiderThanMd } = useWindowSize();
  const [isOpen, setIsOpen] = useState(true);
  const handleNavBtn = () => {
    setIsOpen((prevIsOpen) => !prevIsOpen);
  };
  // const handleBack = () => {
  // TO DEFINE
  //   }
  // };
  return (
    <div className={styles.settingsLayout}>
      <div
        className={clsx(styles.settingsLayout__sidebar, isOpen && styles['settingsLayout__sidebar--open'])}
        role="tablist"
      >
        {!isWiderThanMd && (
          <div className={styles.settingsLayout__sidebar__header}>
            <div className={styles.settingsLayout__sidebar__header__title}>
              {t('ACCOUNT_SETTINGS.MENU.MOBILE_TITLE')}
            </div>
            {/* <button
              className={styles.settingsLayout__backBtn}
              data-cy="settingsLayout_backBtn"
              type="button"
              onClick={handleBack}
            >
              <Icon
                name="arrow-right-long-default"
                className={styles.settingsLayout__btnIcon}
              />
              <span>{tCommon('MODAL.BUTTON.BACK')}</span>
            </button> */}
            {/* <button
              className={styles.settingsLayout__closeBtn}
              data-cy="settingsLayout_closeBtn"
              type="button"
              onClick={handleNavBtn}
              aria-label={tCommon('MODAL.BUTTON.CLOSE')}
            >
              <Icon
                className={styles.settingsLayout__btnIcon}
                name="close-default"
                ariaHidden
              />
              <span className="visuallyhidden">{tCommon('MODAL.BUTTON.CLOSE')}</span>
            </button> */}
          </div>
        )}
        {TAB_NAV_ITEMS.map((item) => (
          <button
            key={item.tab}
            type="button"
            role="tab"
            aria-selected={activeTab === item.tab}
            className={clsx(
              styles.settingsLayout__sidebar__navLink,
              activeTab === item.tab && styles['settingsLayout__sidebar__navLink--active'],
            )}
            onClick={() => {
              onTabChange(item.tab);
              setIsOpen(false);
            }}
            data-cy={`account-settings-tab-${item.tab}`}
          >
            {t(item.translationKey)}
          </button>
        ))}
      </div>
      <div
        className={styles.settingsLayout__content}
        role="tabpanel"
      >
        <div className={styles.settingsLayout__content__header}>
          {!isWiderThanMd && (
            <button
              className={styles.settingsLayout__backBtn}
              type="button"
              onClick={handleNavBtn}
              data-cy="settingsLayout_backBtn"
            >
              <Icon
                name="arrow-right-long-default"
                className={styles.settingsLayout__btnIcon}
                aria-label={tCommon('MODAL.BUTTON.BACK')}
              />
            </button>
          )}
          <h1 className={clsx(styles.settingsLayout__content__header__title, isWiderThanMd && 'visuallyhidden')}>
            {t(TAB_NAV_ITEMS.find((item) => item.tab === activeTab)?.translationKey || TAB_NAV_ITEMS[0].translationKey)}
          </h1>
        </div>
        {children}
      </div>
    </div>
  );
};

export default AccountSettingsLayout;
